import type {WorkflowRunTraceType} from "@/types/workflows";

// Values are `ask` translation keys under `workflowPanel.run.event`.
const TRACE_EVENT_KEYS: Record<WorkflowRunTraceType, string> = {
   workflow_started: "workflowStarted",
   workflow_completed: "workflowCompleted",
   workflow_cancelled: "workflowCancelled",
   workflow_failed: "workflowFailed",
   workflow_timed_out: "workflowTimedOut",
   node_started: "nodeStarted",
   node_completed: "nodeCompleted",
   node_delay_started: "delayStarted",
   node_delay_completed: "delayCompleted",
   node_delay_failed: "delayFailed",
   node_expression_evaluation_failed: "expressionFailed",
   sub_graph_started: "subGraphStarted",
   sub_graph_completed: "subGraphCompleted",
   foreach_started: "forEachStarted",
   foreach_completed: "forEachCompleted",
   foreach_iteration_started: "iterationStarted",
   foreach_iteration_completed: "iterationCompleted",
};

/** A newer Omega may report an event this client does not know yet. */
export const traceEventKey = (type: string): string =>
   Object.hasOwn(TRACE_EVENT_KEYS, type) ? TRACE_EVENT_KEYS[type as WorkflowRunTraceType] : "other";

